import { render, staticRenderFns } from "./NotesMessage.vue?vue&type=template&id=1ff725cf"
import script from "./NotesMessage.vue?vue&type=script&lang=js"
export * from "./NotesMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports